'use client';

import { useState } from 'react';

interface IEnglishIqTextAnswerProps {
  disabled: boolean;
  label: string;
  onAnswer: (answer: string) => void;
  placeholder: string;
  submitLabel: string;
}

export function EnglishIqTextAnswer({
  disabled,
  label,
  onAnswer,
  placeholder,
  submitLabel,
}: IEnglishIqTextAnswerProps): React.JSX.Element {
  const [answer, setAnswer] = useState('');
  const trimmedAnswer = answer.trim();
  const submitAnswer = (): void => {
    if (!disabled && trimmedAnswer) {
      onAnswer(trimmedAnswer);
    }
  };

  return (
    <form
      className="grid gap-3"
      onSubmit={(event) => {
        event.preventDefault();
        submitAnswer();
      }}
    >
      <label className="text-sm font-semibold text-muted-foreground" htmlFor="english-iq-answer">
        {label}
      </label>
      <input
        id="english-iq-answer"
        autoCapitalize="sentences"
        autoComplete="off"
        autoCorrect="off"
        className="min-h-14 rounded-2xl border border-foreground/15 bg-card px-5 py-3 text-base text-foreground outline-none transition focus:border-violet-500 focus:ring-4 focus:ring-violet-500/15 motion-reduce:transition-none disabled:cursor-wait disabled:opacity-60"
        dir="auto"
        disabled={disabled}
        onChange={(event) => setAnswer(event.currentTarget.value)}
        placeholder={placeholder}
        spellCheck={false}
        value={answer}
      />
      <button
        type="submit"
        disabled={disabled || !trimmedAnswer}
        className="min-h-12 rounded-full bg-foreground px-7 py-3 font-semibold text-background transition hover:opacity-85 motion-reduce:transition-none disabled:cursor-not-allowed disabled:opacity-50"
      >
        {submitLabel}
      </button>
    </form>
  );
}
